import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  AfdrachtsVermindering,
  BelastNormaalTarief,
  BelastVerdragsTarief,
  BokkzAlgDataService, BokkzDivDataService, BokkzDivLogic,
  Dividendbelasting,
  DividendTaxEntity, Fonds, InhoudingsVrijstelling,
  LiquidatieUitkering
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-verdragstarief',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedUiDetailsModule, SharedUiFormControlsModule],
  templateUrl: './verdragstarief.component.html',
  styleUrl: './verdragstarief.component.scss',
})
export class VerdragstariefComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private divTaxEntitySubscription: Subscription | undefined;
  public divTaxEntity = {} as DividendTaxEntity;
  public aangifte = {} as Dividendbelasting;
  public dividendFg = {} as FormGroup;
  public belastVerdragsTariefFg = {} as FormGroup;
  public index = 0;
  public formStructure: any;
  public focusedElementId: string | null = null;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsLandcodes: SelectFormControlItem<string>[] = [
    {value: "", label: "--- selecteer ---"},
      {value: "ALB", label: "Albanië"},
    {value: "ARG", label: "Argentinië"},
    {value: "ARM", label: "Armenië"},
    {value: "ABW", label: "Aruba"},
    {value: "AUS", label: "Australië"},
    {value: "AZE", label: "Azerbeidjan"},
    {value: "BHR", label: "Bahrein"},
    {value: "BGD", label: "Bangladesh"},
    {value: "BRB", label: "Barbedos"},
    {value: "BLR", label: "Belarus (Wit-Rusland)"},
    {value: "BEL", label: "België"},
    {value: "BMU", label: "Bermuda"},
    {value: "BES", label: "Bonaire, St. Eustatius en Saba"},
    {value: "BIH", label: "Bosnië-Herzegovina"},
    {value: "BRA", label: "Brazilië"},
    {value: "BGR", label: "Bulgarije"},
    {value: "CAN", label: "Canada"},
    {value: "CHN", label: "China"},
    {value: "CUW", label: "Curaçao"},
    {value: "CYP", label: "Cyprus"},
    {value: "DNK", label: "Denemarken"},
    {value: "DEU", label: "Duitsland"},
    {value: "EGY", label: "Egypte"},
    {value: "EST", label: "Estland"},
    {value: "PHL", label: "Filippijnen"},
    {value: "FIN", label: "Finland"},
    {value: "FRA", label: "Frankrijk"},
    {value: "GEO", label: "Georgië"},
    {value: "GHA", label: "Ghana"},
    {value: "GRC", label: "Griekenland"},
    {value: "HUN", label: "Hongarije"},
    {value: "HKG", label: "Hongkong"},
    {value: "IRL", label: "Ierland"},
    {value: "ISL", label: "IJsland"},
    {value: "IND", label: "India"},
    {value: "IDN", label: "Indonesië"},
    {value: "ISR", label: "Israël"},
    {value: "ITA", label: "Italië"},
    {value: "JPN", label: "Japan"},
    {value: "JOR", label: "Jordanië"},
    {value: "KAZ", label: "Kazachstan"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "KWT", label: "Koeweit"},
    {value: "HRV", label: "Kroatië"},
    {value: "LVA", label: "Letland"},
    {value: "LTU", label: "Litouwen"},
    {value: "LUX", label: "Luxemburg"},
    {value: "MKD", label: "Macedonië"},
    {value: "MWI", label: "Malawi"},
    {value: "MYS", label: "Maleisië"},
    {value: "MLT", label: "Malta"},
    {value: "MAR", label: "Marokko"},
    {value: "MEX", label: "Mexico"},
    {value: "MDA", label: "Moldavië"},
    {value: "MNE", label: "Montenegro"},
    {value: "NZL", label: "Nieuw-Zeeland"},
    {value: "NGA", label: "Nigeria"},
    {value: "NOR", label: "Noorwegen"},
    {value: "UKR", label: "Oekraïne"},
    {value: "UZB", label: "Oezbekistan"},
    {value: "OMN", label: "Oman"},
    {value: "AUT", label: "Oostenrijk"},
    {value: "PAK", label: "Pakistan"},
    {value: "PAN", label: "Panama"},
    {value: "POL", label: "Polen"},
    {value: "PRT", label: "Portugal"},
    {value: "QAT", label: "Qatar"},
    {value: "ROU", label: "Roemenië"},
    {value: "RUS", label: "Rusland"},
    {value: "SAU", label: "Saudi-Arabië"},
    {value: "SRB", label: "Servië"},
    {value: "SGP", label: "Singapore"},
    {value: "SXM", label: "Sint Maarten"},
    {value: "SVN", label: "Slovenië"},
    {value: "SVK", label: "Slowakije"},
    {value: "ESP", label: "Spanje"},
    {value: "LKA", label: "Sri Lanka"},
    {value: "SUR", label: "Suriname"},
    {value: "TJK", label: "Tadzjikistan"},
    {value: "TWN", label: "Taiwan"},
    {value: "THA", label: "Thailand"},
    {value: "CZE", label: "Tsjechië"},
    {value: "TUN", label: "Tunesië"},
    {value: "TUR", label: "Turkije"},
    {value: "UGA", label: "Uganda"},
    {value: "VEN", label: "Venezuela"},
    {value: "GBR", label: "Verenigd Koninkrijk"},
    {value: "ARE", label: "Verenigde Arabische Emiraten"},
    {value: "USA", label: "Verenigde Staten van Amerika"},
    {value: "VNM", label: "Vietnam"},
    {value: "ZMB", label: "Zambia"},
    {value: "ZWE", label: "Zimbabwe"},
    {value: "ZAF", label: "Zuid-Afrika"},
    {value: "KOR", label: "Zuid-Korea"},
    {value: "SWE", label: "Zweden"},
    {value: "CHE", label: "Zwitserland"}
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzDivDataService,
    public divService: BokkzDivLogic,
    private fb: FormBuilder) {
    this.dividendFg = this.fb.group({
      subfund: null as unknown as Fonds,
      bedragDividenduitkering: null as unknown as number,
      bedragOnbelastVerbodExtraterritorialeHeffing: null as unknown as number,
      liquidatieUitkering: null as unknown as LiquidatieUitkering,
      inhoudingsVrijstelling: null as unknown as InhoudingsVrijstelling,
      belastVerdragsTarief: null as unknown as BelastVerdragsTarief,
      belastNormaalTarief: null as unknown as BelastNormaalTarief,
      afdrachtsVermindering: null as unknown as AfdrachtsVermindering,
    })
    this.belastVerdragsTariefFg = this.fb.group<BelastVerdragsTarief>({
      bedragMetVerdragstoepassing: null as unknown as number,
      landCode: null as unknown as string,
      verdragsPercentage: null as unknown as number,
      indicatieVergunningVerdragstoepassing: false,
      indicatieIB92Universeel: false,
      indicatieIB96Usa: false,
      indicatieForm6166: false,
      belastingPerDividend: null as unknown as number,
    })
  }

  ngOnInit(): void {
    this.divTaxEntitySubscription = this.dataService.dividendTaxEntity.subscribe((value) => {
      this.divTaxEntity = value;
      this.aangifte = value.aangifte!;
      if (this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)) {
        this.dividendFg.patchValue(this.aangifte.aangifteDb?.dividendSpecificaties[0], {emitEvent: false})
      }
      if (this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)?.belastVerdragsTarief!) {
        this.belastVerdragsTariefFg.patchValue(this.aangifte.aangifteDb?.dividendSpecificaties?.at(0)?.belastVerdragsTarief!, {emitEvent: false})
      }
    })
  }

  ngOnDestroy(): void {
    if (this.divTaxEntitySubscription) {
      this.divTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.dividendFg.updateValueAndValidity({ emitEvent: false })
    this.belastVerdragsTariefFg.updateValueAndValidity({ emitEvent: false })
    this.dividendFg.value.belastVerdragsTarief = this.belastVerdragsTariefFg.value;
    this.divTaxEntity.aangifte = {
      ...this.aangifte,
      aangifteDb: {
        ...this.aangifte.aangifteDb,
        dividendSpecificaties: [this.dividendFg.value],
      }
    } as Dividendbelasting;
    this.dataService.updateDividendTaxEntity(this.divTaxEntity);
    this.divService.getCalculation(this.divTaxEntity);
  }
}
